/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente List
 */
export const List = styled.div`
  background: white;
  border-radius: 0px 3px 3px 0px;
  padding-bottom: 5px;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    //width: 150px;
  }

  /* ul li {
    position: relative;
  }

  li ul {
    position: absolute;
    left: 149px;
    top: 0;
    display: block;
  }

  ul li span {
      display: block;
      text-decoration: none;
      color: #E2144A;
      background: #fff;
      padding: 5px;
      border: 1px solid #ccc;
    }

  li:hover ul { display: block; } */
`;

/**
 * Estilização do componente Loader
 */
export const Loader = styled.div`
  .layer-loader {
    margin: 15px 0;
    padding: 0 10px;
  }
`;
